import { JOB_SIZES, START_LABELS } from "@/lib/requestLabels";

// customer_form_responses (v1) from brugo-web's short form.
export function FormResponses({ cfr }) {
  if (!cfr) return null;
  const row = (k, v) => (
    <div className="flex justify-between gap-3 text-xs py-1 border-b border-border last:border-0">
      <span className="text-muted-foreground">{k}</span><span className="text-right text-foreground break-words">{v ?? "—"}</span>
    </div>
  );
  return (
    <div className="rounded-lg border border-border p-3 mt-3" data-testid="customer-form-responses">
      <p className="text-[10px] font-mono uppercase tracking-wider text-muted-foreground mb-2">customer_form_responses · v{cfr.version ?? "?"} · {cfr.journey || "—"}</p>
      {(cfr.services || []).map((s, i) => (
        <div key={i} className="mb-2 rounded-md bg-secondary/60 p-2 text-xs" data-testid={`cfr-service-${i}`}>
          <p className="font-medium text-foreground">{s.name || s.category_id}</p>
          <p className="text-muted-foreground">Job: {[...(s.job || []), s.job_other].filter(Boolean).join(", ") || "—"}</p>
        </div>
      ))}
      {row("Job size", JOB_SIZES[cfr.job_size] || cfr.job_size)}
      {row("How soon", START_LABELS[cfr.start_when] || cfr.start_when)}
      {row("Notes", cfr.notes || "—")}
      {row("Photos", cfr.photos ?? 0)}
      {row("Address", [cfr.address, cfr.city, cfr.pincode].filter(Boolean).join(", ") || "—")}
      {row("Visit", cfr.visit?.flexible ? "Any time is fine" : `${cfr.visit?.date || "—"} ${(cfr.visit?.slots || []).join(", ")}`)}
    </div>
  );
}
